export const width = 310;
export const height = 40;
export const defaultScrollAreaHeight = 300;

export const expandedHeights = {
    allStatements: 50,
    manageOrAddStatements: 50,
    regionFilter: 56, // 56 = 40 (regionFilterDropdown) plus my-2, which is 1rem or 16px
    regionFilterDropdown: 40,
    scrollAreaItem: 50,
    viewSelected: 55,
    yearToDate: 50,
    clearAll: 50,
    statementPeriodInfo: 78,
};

export const presetClasses =
    'font-medium pl-4 border-b border-tertiary-100 flex items-center';
